import React from "react";
import "./pieChart.scss";

interface PieData {
  label: string;
  value: number;
  color: string;
}

interface PieChartProps {
  data: PieData[];
  radius?: number;
}

const PieChart: React.FC<PieChartProps> = ({ data, radius = 80 }) => {
  const total = data?.reduce((a, b) => a + b.value, 0);
  let cumulative = 0;
  const segments = data?.map((d) => {
    const start = (cumulative / total) * 360;
    cumulative += d.value;
    const end = (cumulative / total) * 360;
    return `${d.color} ${start}deg ${end}deg`;
  });

  return (
    <div className="pie-chart">
      <div
        className="circle"
        style={{
          background: `conic-gradient(${segments?.join(",")})`,
          width: radius * 2,
          height: radius * 2,
        }}
      />
      <ul className="legend">
        {data?.map((d, i) => (
          <li key={i}>
            <span className="dot" style={{ background: d.color }}></span>
            {d.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PieChart;
